<template>
  <div id="addSchedule">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="12" xl="8">
                  <BaseInput :options="titleInput.options" :data="titleInput.data" ref="titleInput" />
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8">
                  <BaseSelect :options="typeSourceSelect.options" :data="typeSourceSelect.data" ref="typeSourceSelect">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8">
                  <div class="form-group form-row" :class="{
                    'input-valid-error': fileSelectedInput.data.validator && !fileSelectedInput.data.validator.isValid,
                    'no-label': !(fileSelectedInput.options && fileSelectedInput.options.label)
                  }" v-if="typeSourceSelect.data.model == 0 || typeSourceSelect.data.model == 1">
                    <label class="col-form-label col-sm-3" v-html="fileSelectedInput.options.label"></label>
                    <div class="col-sm-9">
                      <input type="text" :placeholder="fileSelectedInput.options.placeholder" class="form-control"
                        readonly v-model="fileSelectedInput.data.title" @click="chooseFile()" ref="fileSelectedInput" />
                      <!-- <span class="col-sm-3"></span> -->
                      <div class="valid-error"
                        v-show="!(fileSelectedInput.data.validator ? fileSelectedInput.data.validator.isValid : true)">
                        {{ fileSelectedInput.data.validator ? fileSelectedInput.data.validator.errorMessage : "" }}
                      </div>
                    </div>
                  </div>
                  <BaseSelect v-show="typeSourceSelect.data.model == 2" :options="channelDigitalSelect.options"
                    :data="channelDigitalSelect.data" ref="channelDigitalSelect">
                  </BaseSelect>
                  <BaseSelect v-show="typeSourceSelect.data.model == 3" :options="playListSelect.options"
                    :data="playListSelect.data" ref="playListSelect">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8">
                  <BaseSelect :options="modeSelect.options" :data="modeSelect.data" ref="modeSelect">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8" v-if="modeSelect.data.model != 2">
                  <BaseSelect :options="prioritySelect.options" :data="prioritySelect.data" ref="prioritySelect">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8" v-if="modeSelect.data.model != 2">
                  <div class="form-group form-row">
                    <label for="dateRanger" class="col-form-label col-sm-3">Ngày bắt đầu - Ngày kết thúc
                      <span class="required">* </span>
                      <span class="explain" data-toggle="tooltip" data-html="true"
                        title="<div class='text-left'><b>- Ngày bắt đầu - ngày kết thúc:</b> Là khoảng thời gian hiệu lực của lịch phát thanh được gửi tới thiết bị. Nếu người dùng muốn đặt lịch cho cả tháng, chọn ngày bắt đầu là ngày 1 đầu tháng đến ngày kết thúc là 30 (hoặc 28,29,31) cuối tháng.
                    <br/><i>Lưu ý:<br/>
                              + Với lịch phát trong nhiều ngày, người dùng nhấn chuột lần đầu để chọn ngày bắt đầu, bấm chọn lần tiếp vào ngày muốn chọn làm ngày kết thúc,
                              lịch phát sẽ được thực thi trong khoảng thời gian được chọn với Thời gian phát tương ứng.<br/>
                              + Với lịch phát trong một ngày duy nhất, người dùng nhấn chuột 2 lần vào cùng 1 ngày mong muốn, hệ thống sẽ tự động nhận ngày bắt đầu và ngày
                              kết thúc tại cùng một ngày, và lịch phát sẽ được thực thi trong duy nhất ngày được chọn.</i></div>">
                        <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                    </label>
                    <DatePicker id="dateRanger" v-model="dateRange" is-range locale="vi" class="datepicker col-sm-9"
                      :input-props="{ readonly: true }" :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
                      :min-date="new Date()" :popover="{ visibility: 'click' }">
                      <template v-slot="{ inputValue, inputEvents }">
                        <input :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                          class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300 " readonly />
                      </template>
                    </DatePicker>
                  </div>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8" v-if="modeSelect.data.model == 1">
                  <BaseSelect :options="modeSchedule.options" :data="modeSchedule.data" ref="modeSchedule">
                  </BaseSelect>
                </CCol>

                <CCol xs="12" sm="12" md="12" xl="8" v-if="modeSchedule.data.model == 0 && modeSelect.data.model == 1">
                  <div class="form-group form-row" ref="selectedDateWeek">
                    <label class="col-form-label col-sm-3">Ngày phát <span class="required">* </span>
                      <span class="explain" data-toggle="tooltip" data-html="true"
                        title="<div class='text-left'><b style='color: black'>- Đối với kiểu lịch Theo ngày trong tuần:</b> Người dùng chọn các thứ trong tuần lịch phát có hiệu lực.
                          <br/><i style='color: red'>Ví dụ: trong khoảng thời gian hiệu lực ( Ngày bắt đầu - Ngày kết thúc) 1 tháng,
                          người dùng chỉ chọn thứ 2,3,4,5,6, các ngày thứ 7, chủ nhật trong khoảng thời gian 1 tháng đó sẽ không có lịch phát thanh ra các thiết bị</i></div>">
                        <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                    </label>
                    <div class="col-sm-9">
                      <multiselect id="selectedDateWeek" v-model="selectedDateWeek.data.model" placeholder="Ngày phát"
                        label="value" track-by="key" :options="selectedDateWeek.data.items" selectLabel="Chọn"
                        deselectLabel="Bỏ chọn" selectedLabel="Đã chọn" :close-on-select="false" :multiple="true"
                        :class="!(selectedDateWeek.data.validator ? selectedDateWeek.data.validator.isValid : true) ? 'input-error' : ''">
                        <span slot="noResult">Không có dữ liệu tương ứng!</span>
                        <span slot="noOptions">Danh sách rỗng!</span>
                      </multiselect>
                      <!-- <span class="col-sm-3"></span> -->
                      <div class="valid-error"
                        v-show="!(selectedDateWeek.data.validator ? selectedDateWeek.data.validator.isValid : true)">
                        {{ selectedDateWeek.data.validator ? selectedDateWeek.data.validator.errorMessage : "" }}
                      </div>
                    </div>
                  </div>
                </CCol>

                <CCol xs="12" sm="12" md="12" xl="8" v-if="modeSelect.data.model == 1 && modeSchedule.data.model == 1">
                  <div class="form-group form-row" ref="rangeDates"
                    :class="!(validatorDates ? validatorDates.isValid : true) ? 'input-error' : ''">
                    <label class="col-form-label col-sm-3">Ngày phát <span class="required">* </span>
                      <span class="explain" id="123" data-toggle="tooltip" data-html="true"
                        title="<div class='text-left'><b style='color: black'>- Đối với kiểu lịch Theo ngày trong tháng:</b> Người dùng chọn các ngày chỉ định
                          trong tháng để lịch phát có hiệu lực.
                          <br/><i style='color: red'>Ví dụ: trong khoảng thời gian hiệu lực ( Ngày bắt đầu - Ngày kết thúc) 1 tháng,
                           người dùng chỉ chọn ngày 1,2,3,4,5,6,7, các ngày còn lại trong khoảng thời gian 1 tháng đó sẽ không có lịch phát thanh ra các thiết bị</i></div>">
                        <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                    </label>
                    <div class="col-sm-9">
                      <CCard class="mb-1 ">
                        <CCardBody style="padding-top: 5px !important">
                          <DatePicker id="datepicker" mode="date" locale="vi" v-model="selectedDate.date"
                            :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }" :min-date="minDate" :max-date="maxDate"
                            :is-required="true" :popover="{ visibility: 'click' }">
                            <template #default="{
                              inputValue,
                              togglePopover,
                              hidePopover,
                            }">
                              <div class="flex flex-wrap">
                                <CButton v-for="(each, i) in dates"
                                  :key="each.date != null ? each.date.getTime() : new Date().getTime()" color="light"
                                  class="mr-3 mt-3 btn-date" style="position: relative"
                                  @click.stop=" dateSelected($event, each, togglePopover)" ref="btnDate">
                                  {{
                                    each.date != null ? $helper.formatDateDDMMYYYY(each.date) :
                                    $helper.formatDateDDMMYYYY(new
                                      Date())
                                  }}
                                  <div class="btn-remove">
                                    <svg class="w-1 h-1" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
                                      @click.stop="removeDate(each, hidePopover)">
                                      <path d="M6 18L18 6M6 6l12 12"></path>
                                    </svg>
                                  </div>
                                </CButton>
                              </div>
                            </template>
                          </DatePicker>
                          <CButton color="primary" class="mt-3" :disabled="checkDisableAddDate" @click="addDate">
                            <i class="fa fa-plus"></i>&nbsp;Thêm ngày
                          </CButton>
                          <CButton color="secondary" class="mt-3 ml-2" @click="dates = []">
                            <i class="fa fa-eraser"></i>&nbsp;Xóa tất cả
                          </CButton>
                        </CCardBody>
                      </CCard>
                      <!-- <span class="col-sm-3"></span> -->
                      <div class="valid-error" v-show="!(validatorDates ? validatorDates.isValid : true)">
                        {{ validatorDates ? validatorDates.errorMessage : "" }}
                      </div>
                    </div>
                  </div>
                </CCol>

                <CCol xs="12" sm="12" md="12" xl="8" v-if="(typeSourceSelect.data.model == 0 || typeSourceSelect.data.model == 3)">
                  <BaseSelect :options="modeTimeSelect.options" :data="modeTimeSelect.data" ref="modeTimeSelect">
                  </BaseSelect>
                </CCol>

                <CCol xs="12" sm="12" md="12" xl="8" v-if="(modeSelect.data.model == 1 || modeSelect.data.model == 0)">
                  <div class="form-group form-row mb-0"
                    :class="!(validatorRangeTimes ? validatorRangeTimes.isValid : true) ? 'input-error' : ''">
                    <label class="col-form-label col-sm-3" v-show="(modeTimeSelect.data.model == 1)">Thời gian phát
                      <span class="required">* </span>
                      <span class="explain" data-toggle="tooltip" data-html="true" 
                        title="<div class='text-left'><b>- Thời gian phát :</b> Là khung giờ phát được đặt theo khoảng thời gian hiệu lực
                            (Ngày bắt đầu- ngày kết thúc) cho các thiết bị, người dùng nhấn nút Thêm để tạo mới khung giờ thời gian phát,
                            tiếp tục nhấn chọn vào khung thời gian để chọn thời gian bắt đầu và thời gian kết thúc của lịch phát.
                                <i>Lưu ý: Khi đặt lịch với thời gian phát tương ứng, người dùng chú ý định dạng của Thời gian phát ( định dạng giờ 24) như sau
                                <br/>+ Nếu mong muốn lịch phát là 5 giờ sáng đến 7 giờ sáng, người dùng thêm thời gian phát là 05:00 - 07:00.
                                <br/>+ Nếu mong muốn lịch phát là 5 giờ chiều đến 7 giờ chiều, người dùng thêm thời gian phát là 17:00 - 19:00</i></div>">
                        <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                    </label>
                    <label class="col-form-label col-sm-3" v-show="(modeTimeSelect.data.model == 0)">Thời gian bắt đầu
                      <span class="required">* </span>
                      <span class="explain" data-toggle="tooltip" data-html="true"
                        title="<div class='text-left'><b>- Thời gian phát :</b> Là thời gian bắt đầu của bản tin bắt đầu được phát và thời lượng tuân theo số lần phát được nhập.<br/>
                          Ví dụ: Bản tin phát thanh có thời lượng là 5 phút 10 giây (00:05:10), nhập vào thời gian bắt đầu là 10:00 (10h00 sáng), số lần là 6, bản tin sẽ phát từ 10h00 đến 10h31.<br/>
                                <i>Lưu ý: Việc phát lặp lại cho phép đặt lịch không giới hạn số lần, người dùng tính toán số lần để có thời lượng hợp lý với nhu cầu phát thanh. Nếu muốn dừng bản thanh khi chưa hết thời gian, sử dụng thao tác dừng phát thanh.
                                </i></div>">
                        <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                      <br/>Số lần
                    </label>
                    <div class="col-sm-9">
                      <CCard class="mb-1 " ref="rangeTimes">
                        <CCardBody style="padding-top: 5px !important">
                          <CRow v-if="(modeTimeSelect.data.model == 1)">
                            <CCol sx="12" sm="12" md="6" lg="6" xl="3" v-for="(each, index) in timeRange"
                              :key="index+'unique'+each.start.getTime()">
                              <DatePicker mode="time" :masks="{ input: 'HH:MM', data: 'HH:MM' }" :value="each" is-range
                                is24hr :popover="{ visibility: 'click' }" @input="changeTimeRange($event, index)"
                                ref="timeRange">
                                <template v-slot="{ inputValue, inputEvents, togglePopover, hidePopover }">
                                  <!--                                <CInput class="btn-time-ranger"-->
                                  <!--                                        :value="inputValue.start + ' - ' + inputValue.end"-->
                                  <!--                                        v-on="inputEvents.start"-->
                                  <!--                                        readonly-->
                                  <!--                                />-->
                                  <div class="form-group">
                                    <input type="text" :style="each.isValid ? 'border-color:red!important;' : ''"
                                      class="btn-time-ranger form-control"
                                      :value="inputValue.start + ' - ' + inputValue.end" readonly
                                      v-on="inputEvents.start">
                                  </div>
                                  <svg v-c-tooltip.hover="'Xóa'" class="w-1 h-1 btn-remove-time" viewBox="0 0 24 24"
                                    stroke="currentColor" stroke-width="2" @click="removeTimeRange(index)">
                                    <path d="M6 18L18 6M6 6l12 12"></path>
                                  </svg>
                                </template>
                              </DatePicker>
                            </CCol>
                          </CRow>
                          <CRow v-if="(modeTimeSelect.data.model == 0)">
                            <CCol sx="12" sm="12" md="6" lg="6" xl="3" v-for="(each, index) in timeRange"
                              :key="index+'unique'+each.start.getTime()">
                              <DatePicker mode="time" :masks="{ input: 'HH:MM', data: 'HH:MM' }" :value="each.start"
                                is24hr :popover="{ visibility: 'click' }" @input="changeTimeRange($event, index, each.replay)"
                                ref="timeRange">
                                <template v-slot="{ inputValue, inputEvents, togglePopover, hidePopover }">
                                  <div class="form-group">
                                    <input type="text" :style="each.isValid ? 'border-color:red!important;' : ''"
                                      class="btn-time-ranger form-control"
                                      :value="inputValue" readonly
                                      v-on="inputEvents">
                                    <input type="number" class="btn-time-ranger form-control" v-model="each.replay" @change="changeTimeRange(each.start, index, each.replay)">
                                    <!-- <select class="group-select btn-time-ranger form-control" style="width: 100%;">
                                      <option value="1">x1</option>
                                      <option value="2">x2</option>
                                      <option value="3">x3</option>
                                      <option value="4">x4</option>
                                      <option value="5">x5</option>
                                      <option value="6">x6</option>
                                      <option value="7">x7</option>
                                      <option value="8">x8</option>
                                      <option value="9">x9</option>
                                      <option value="10">x10</option>
                                    </select> -->
                                  </div>
                                  <svg v-c-tooltip.hover="'Xóa'" class="w-1 h-1 btn-remove-time" viewBox="0 0 24 24"
                                    stroke="currentColor" stroke-width="2" @click="removeTimeRange(index)">
                                    <path d="M6 18L18 6M6 6l12 12"></path>
                                  </svg>
                                </template>
                              </DatePicker>
                            </CCol>
                          </CRow>
                          <CRow>
                            <CCol>
                              <CButton color="primary" class="mt-3" @click="addTimeRange()">
                                <i class="fa fa-plus"></i>&nbsp;Thêm
                              </CButton>
                              <CButton color="secondary" class="mt-3 ml-2" @click="sortRangeTime(true)">
                                <i class="fa fa-sort"></i>&nbsp;Sắp xếp
                              </CButton>
                              <CButton color="secondary" class="mt-3 ml-2" @click="timeRange = []">
                                <i class="fa fa-eraser"></i>&nbsp;Xóa tất cả
                              </CButton>
                            </CCol>
                          </CRow>
                        </CCardBody>
                      </CCard>
                      <div class="valid-error" v-show="!(validatorRangeTimes ? validatorRangeTimes.isValid : true)">
                        {{ validatorRangeTimes ? validatorRangeTimes.errorMessage : "" }}
                      </div>
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8" v-if="modeSelect.data.model == 2">
                  <div class="form-group form-row" v-if="(modeTimeSelect.data.model == 1)"
                    :class="!(validatorEndTimeUrgency ? validatorEndTimeUrgency.isValid : true) ? 'input-error' : ''">
                    <label for="datepicker" class="col-form-label col-sm-3">Thời gian kết thúc phát
                      <span class="required">* </span>
                      <span class="explain" id="endTime" data-toggle="tooltip" data-html="true"
                        title="<div class='text-left'>Người dùng chỉ cần nhập thời gian kết thúc lịch phát khẩn cấp, chọn thiết bị thực hiện, thời gian bắt đầu được tính tại thời điểm lịch phát được lưu.</div>">
                        <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                    </label>
                    <div class="col-sm-9">
                      <DatePicker ref="endTimeUrgency" id="endTimeUrgencyPicker" mode="time" v-model="endTimeUrgency"
                        :masks="{ input: 'HH:MM', data: 'HH:MM' }" is24hr>
                      </DatePicker>
                      <div class="col-sm-3"></div>
                      <div class="valid-error col-sm-8" style="padding: unset!important;"
                        v-show="!(validatorEndTimeUrgency ? validatorEndTimeUrgency.isValid : true)">
                        {{ validatorEndTimeUrgency ? validatorEndTimeUrgency.errorMessage : "" }}
                      </div>
                    </div>
                  </div>

                  <div class="form-group form-row" v-if="(modeTimeSelect.data.model == 0)"
                    :class="!(validatorEndTimeUrgency ? validatorEndTimeUrgency.isValid : true) ? 'input-error' : ''">
                    <label for="datepicker" class="col-form-label col-sm-3">Số lần lặp lại
                      <span class="required">* </span>
                      <span class="explain" id="endTime" data-toggle="tooltip" data-html="true"
                        title="<div class='text-left'>Người dùng chỉ cần nhập số lần lặp lại của lịch phát khẩn cấp, chọn thiết bị thực hiện, thời gian bắt đầu được tính tại thời điểm lịch phát được lưu.</div>">
                        <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                    </label>
                    <div class="col-sm-9">
                      <input type="number" class="btn-time-ranger form-control" v-model="replayUrgency" @change="changeReplayUrgency(replayUrgency)">
                      <div class="col-sm-3"></div>
                    </div>
                  </div>
                </CCol>
                
                
                <CCol xs="12" sm="12" md="12" xl="8">
                  <BaseSelect :options="scheduleBySelect.options" :data="scheduleBySelect.data" ref="scheduleBySelect">
                  </BaseSelect>
                </CCol>
              </CRow>

              <!-- Đặt lịch theo địa bàn -->
              <CRow v-if="scheduleBySelect.data.model == 0">
                <!-- <CCol xs="12" sm="12" md="12" xl="8" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
                  <BaseSelect :options="districtCodeScheduleInput.options" :data="districtCodeScheduleInput.data"
                              ref="districtCodeScheduleInput"></BaseSelect>
                </CCol> -->
                <CCol xs="12" sm="12" md="12" xl="8">
                  <BaseSelect :options="levelLocationSelect.options" :data="levelLocationSelect.data"
                    ref="levelLocationSelect">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="12" xl="8">
                  <div class="form-group form-row" ref="locationScheduleSelected">
                    <label style="display: inline-flex;" class="col-form-label col-sm-3">Địa bàn&nbsp;<span
                        class="required">*</span>&nbsp;
                      <span class="explain" data-toggle="tooltip" data-html="true" title="Địa bàn phát bản tin">
                        <i class="fa fa-question-circle-o" style="font-size: 18px; cursor: pointer"></i>
                      </span>
                      <CInputCheckbox custom :checked="isSelectedAllLocation" class="ml-2"
                        @update:checked="changeSelectedAllLocation($event)" addInputClasses="override-custom">
                      </CInputCheckbox>
                      Chọn tất cả
                    </label>
                    <div class="col-sm-9">
                      <multiselect id="locationScheduleSelected" v-model="locationScheduleSelected.data.model"
                        placeholder="Địa bàn" label="value" track-by="key" :options="locationScheduleSelected.options"
                        selectLabel="Chọn" deselectLabel="Bỏ chọn" selectedLabel="Đã chọn" :close-on-select="false"
                        :multiple="true"
                        :class="!(locationScheduleSelected.data.validator ? locationScheduleSelected.data.validator.isValid : true) ? 'input-error' : ''">
                        <span slot="noResult">Không có dữ liệu tương ứng!</span>
                        <span slot="noOptions">Danh sách rỗng!</span>
                      </multiselect>
                      <!-- <span class="col-sm-3"></span> -->
                      <div class="valid-error"
                        v-show="!(locationScheduleSelected.data.validator ? locationScheduleSelected.data.validator.isValid : true)">
                        {{ locationScheduleSelected.data.validator ? locationScheduleSelected.data.validator.errorMessage
                          :
                          "" }}
                      </div>
                    </div>
                  </div>
                </CCol>
                <!-- <CCol xs="12" sm="12" md="12" xl="8" v-if="!$hasAuthor('ROLE_WARD')">
                  <BaseSelect :options="wardCodeScheduleInput.options" :data="wardCodeScheduleInput.data"
                              ref="wardCodeScheduleInput"></BaseSelect>
                </CCol> -->
              </CRow>
              <!-- Danh sách thiết bị -->
              <BaseFormDevice v-else @un-selected="unSelectedDevice" @change-selected="changeSelectedDevice"
                @clear:selectedAll="clearSelectedAll" @dataSearch="dataSearch" :reset="resetDevice"
                :isValid="!deviceInput.validator.isValid" @selectedAll="selectedAll"
                @change-valid="changeValidateDevice($event)"></BaseFormDevice>
              <br />


              <CRow>
                <CCol xs="12" md="12" lg="12" xl="12">
                  <CButton color="primary" @click="submitData()"><i class="fa fa-save"></i>&nbsp;Đặt lịch
                  </CButton>
                  <CButton color="secondary" class="ml-2" @click="resetData()"><i class="fa fa-eraser"></i>&nbsp;Làm mới
                  </CButton>
                  <CButton color="secondary" class="ml-2" @click="$router.go(-1)"><i class="fa fa-reply"></i>&nbsp;Hủy bỏ
                  </CButton>
                </CCol>
              </CRow>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal title="Lịch phát đã tồn tại" :show.sync="exist.isShowModelExist" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" md="12" lg="12" xl="12">
          Đã tồn tại lịch phát ngày <span style="font-weight:bold">{{ exist.playDate }}</span>
          khung giờ <span style="font-weight:bold">{{ exist.startTime + ' - ' + exist.endTime }}</span>
          <br v-if="exist.mode == 2" /><span style="color: #ff0303; font-weight: bold;" v-if="exist.mode == 2">
            (Đây là lịch phát khẩn cấp của cấp trên: {{ exist.locationName }}. Nếu xác nhận ghi đè, người dùng sẽ chịu
            trách nhiệm cho thao tác này)
          </span>
          <br />
          với các thiết bị:
          <br />
          <span v-for="i of exist.devices">
            {{ i + '; ' }}
          </span>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="exist.isShowModelExist = false"><i
            class="fa fa-times"></i>&nbsp;Hủy bỏ
        </button>
        <button v-if="exist.mode == 2" type="button" class="btn btn-primary" @click="submitConfirm()">
          <i class="fa fa-save"></i>&nbsp;Xác nhận ghi đè lịch
        </button>
        <button v-else type="button" class="btn btn-primary"
          @click="$router.push(`${exist.id}/managed-schedule-detail.html`)">
          <i class="fa fa-eye"></i>&nbsp;Xem lịch đã tồn tại
        </button>
      </template>
    </CModal>

    <FileManagementAddSchedule v-if="chooseFileData.isShowModal" @file:selected="chooseFileSelected($event)"
      @close-modal="closeModalChooseFile($event)"></FileManagementAddSchedule>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import { DatePicker } from "v-calendar";
import Multiselect from "vue-multiselect";
import BaseLoading from "@/views/base/BaseFormLoading";
import BaseFormDevice from "@/views/base/BaseFormDevice";
import FileManagementAddSchedule from "@/views/base/FileManagementAddSchedule";
import { Authorities } from '../../constant';

export default {
  name: "ScheduleAdd",
  components: {
    FileManagementAddSchedule,
    BaseFormDevice,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    Multiselect,
    BaseLoading,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      timeout: 10000
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    let today = new Date();
    return {
      isConfirm: true,
      isSelectedAllDevices: false,
      loading: { value: false },
      minDate: today,
      maxDate: today,
      dates: [],
      selectedDate: {},
      isSelectedAllLocation: false,
      duration: "00:00:00",
      exist: {
        id: "",
        msg: "",
        playDate: "",
        startTime: "",
        endTime: "",
        devices: [],
        isShowModelExist: false,
        mode: "",
        locationName: ""
      },
      endTimeUrgency: this.$helper.plusDateTime(10, 'm')._d,
      replayUrgency: 1,
      actionData: {
        model: {
          listFileSelectedId: [],
          deviceIgnoreIds: [],
          dataSearch: {},
          selectedAll: false
        },
      },
      dateRange: {
        start: new Date(),
        end: new Date(),
      },
      timeRange: [],
      locationScheduleSelected: {
        options: [],
        data: {
          name: "scheduleLocationCode",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.locationScheduleSelected.data.model;
              if (value === "" || that.locationScheduleSelected.data.model.length == 0) {
                this.isValid = false;
                this.errorMessage = "Địa bàn không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      levelLocationSelect: {
        options: {
          label: "Cấp địa bàn <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"> Cấp địa bàn Tỉnh/Thành Phố, Quận/Huyện, Phường/Xã " +
            "'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: false,
          disabled: (this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_MANAGEMENT')) ? false : true,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          }
        },
        data: {
          name: "levelLocation",
          items:
            [
              { key: "0", value: "Tỉnh/Thành phố" },
              { key: "1", value: "Quận/Huyện" },
              { key: "2", value: "Phường/Xã" },
            ],
          model: (this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_MANAGEMENT')) ? "1" : "2",
        },
      },
      titleInput: {
        options: {
          label: "Tên lịch phát <span class='required'>*</span>",
          placeholder: "Tên lịch phát",
          maxlength: 50,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          },
          addInputClasses: 'titleInput'
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "" || value.trim() === "") {
                this.isValid = false;
                this.errorMessage = "Tên lịch phát không được để trống";
                that.scrollToValidate(that.$refs.titleInput.$el.scrollHeight);
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      typeSourceSelect: {
        options: {
          label: "Nguồn phát <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>- Nguồn phát Tập tin âm anh từ kho biên tập:</b> " +
            "Là nguồn phát của tập tin biên tập tại kho lưu trữ, để sử dụng nguồn phát này cho đặt lịch, người dùng cần biên tập tải lên tệp tin tại chức năng " +
            "<i>Quản lý ND & biên tập -> Biên tập nội dung -> Thêm mới</i>" +
            "<br/><b>- Nguồn phát Kênh số hoá:</b> Là nguồn phát đã được số hoá và luôn trực tuyến, ví dụ như Kênh VOV, đài số hoá địa phương tại Huyện, Tỉnh...'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: false,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          },
        },
        data: {
          name: "mode",
          items: [
            { key: "0", value: "Tập tin âm thanh từ kho biên tập" },
            // {key: "1", value: "Tập tin âm thanh chuyển đổi văn bản sang giọng đọc"},
            { key: "2", value: "Kênh số hóa Radio" },
            { key: "3", value: "Danh sách phát từ kho biên tập" },
          ],
          model: "0",
        },
      },
      fileSelectedInput: {
        options: {
          label: "Tệp tin <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>Tệp tin:</b> Người dùng chọn tệp tin đã được biên tập tải lên tại kho lưu trữ để đặt lịch." +
            "<br/><i>Lưu ý: để tìm tệp tin cần chọn nhanh và chính xác nhất, người dùng cần chú ý lọc khoảng thời gian ngày tạo bản tin, loại tệp tin và địa bàn tương ứng.</i>'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          placeholder: 'Chọn tệp tin ...'
        },
        data: {
          title: "",
          name: "name",
          model: "",
          // duration: "00:00:00",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.fileSelectedInput.data.model;
              if (value === "" && (that.typeSourceSelect.data.model == 0 || that.typeSourceSelect.data.model == 1)) {
                this.isValid = false;
                this.errorMessage = "Tệp tin phát thanh không được để trống";
                that.scrollToValidate(that.$refs.fileSelectedInput.scrollHeight);
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        }
      },
      channelDigitalSelect: {
        options: {
          label: "Kênh số hóa <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>- Kênh số hoá:</b> Là danh sách các kênh đài phát thanh đã được số hoá và hiển thị khi trực tuyến " +
            "(nguồn phát có tín hiệu và sẵn sàng), người dùng chọn một kênh trong danh sách này để thực hiện đặt lịch'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: true,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          },
          lazyLoad: true,
          'keyField': 'key',
          'valueField': 'value',
          selectAllText: "Chọn kênh số hóa",
        },
        data: {
          name: "channelDigital",
          items: [],
          model: "",
          source: {
            url: '/common/listChannelDigital',
            isJsonContentType: false,
            dataSubmit: function () {
              return {
                name: '',
                locationCode: ''
              }
            },
            response: function (dataResponse) {
              that.channelDigitalSelect.data.items = dataResponse.data;
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.channelDigitalSelect.data.model;
              if (value === "" && that.typeSourceSelect.data.model == 2) {
                this.isValid = false;
                this.errorMessage = "Kênh số hóa không được để trống";
                that.scrollToValidate(that.$refs.channelDigitalSelect.$el.scrollHeight);
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      playListSelect: {
        options: {
          label: "Danh sách phát <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>- Danh sách phát:</b> Là danh sách các tệp tin được biên tập làm danh sách" +
            ", người dùng chọn một kênh trong danh sách này để thực hiện đặt lịch'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: true,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          },
          lazyLoad: true,
          'keyField': 'key',
          'valueField': 'value',
          selectAllText: "Chọn danh sách phát",
        },
        data: {
          name: "playList",
          items: [],
          model: "",
          source: {
            url: '/common/listPlaylist',
            isJsonContentType: false,
            dataSubmit: function () {
              return {
                name: '',
                locationCode: ''
              }
            },
            response: function (dataResponse) {
              that.playListSelect.data.items = dataResponse.data;
            }
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.playListSelect.data.model;
              if (value === "" && that.typeSourceSelect.data.model == 3) {
                this.isValid = false;
                this.errorMessage = "Danh sách phát không được để trống";
                that.scrollToValidate(that.$refs.playListSelect.$el.scrollHeight);
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      scheduleBySelect: {
        options: {
          label: "Đặt lịch theo <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>- Đặt lịch theo địa bàn:</b> Là đặt lịch cho tất cả thiết bị trên địa bàn. " +
            "<br/><b>- Đặt lịch theo thiết bị:</b> Là đặt lịch cho các thiết bị được chọn trên địa bàn." +
            "'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: false,
          disabled: this.$hasAuthor('ROLE_VILLAGE') ? true : false,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          }
        },
        data: {
          name: "scheduleBy",
          items:
            [
              { key: "0", value: "Đặt lịch theo địa bàn" },
              { key: "1", value: "Đặt lịch theo thiết bị" }
            ],
          model: this.$hasAuthor('ROLE_VILLAGE') ? "1" : "0",
        },
      },
      modeTimeSelect: {
        options: {
          label: "Loại giờ phát<span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>- Phát lặp lại (Theo số lần phát):</b> Là phát lặp lại theo số lần phát. " +
            "<br/><b>- Phát theo khung giờ (Thời gian bắt đầu - Kết thúc):</b> Là phát theo khoảng thời gian bắt đầu - kết thúc." +
            "'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: false,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          }
        },
        data: {
          name: "modeTime",
          items:
            [
              { key: "0", value: "Phát lặp lại (Theo số lần phát)" },
              { key: "1", value: "Phát theo khung giờ (Thời gian bắt đầu - Kết thúc)" },
            ],
          model: "0",
        },
      },
      modeSelect: {
        options: {
          label: "Chế độ phát <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>- Khung giờ cố định:</b> Là chế độ lịch phát trong khoảng thời gian có hiệu lực. " +
            "Người dùng chỉ cần đặt giờ phát để các thiết bị phát thanh với nguồn phát được chọn khi đến lịch toàn bộ các ngày trong tuần." +
            "<br/><b>- Theo lịch phát đã thiết lập:</b> Là chế độ lịch phát trong các ngày chỉ định thuộc khoảng thời gian có hiệu lực." +
            "<br/><b>- Khẩn cấp phát ngay:</b> Là chế độ lịch phát 1 lần khẩn cấp ngay lập tức tại thời điểm thực hiện đặt lịch.'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: false,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          }
        },
        data: {
          name: "mode",
          items:
            [
              { key: "0", value: "Khung giờ cố định" },
              { key: "1", value: "Theo lịch phát đã thiết lập" },
              { key: "2", value: "Khẩn cấp phát ngay" },
            ],
          model: "0",
        },
      },
      prioritySelect: {
        options: {
          label: "Chế độ lịch ưu tiên <span class='required'>*</span> " +
            "<span class='explain' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>- Chế độ lịch ưu tiên:</b> Là chế độ mức ưu tiên phát của lịch phát" +
            "<br/>- Đối với chế độ lịch \"Không ưu tiên\", lịch được phát dưới dạng thường. Các lịch không ưu tiên này không thể đặt lịch chèn lên cách lịch thường và lịch ưu tiên đã tồn tại trên hệ thống." +
            "<br/>- Đối với chế độ lịch \"Ưu tiên\", lịch ưu tiên có thể đặt lịch chèn lên lịch thường không ưu tiên đã tồn tại, nhưng không thể đặt lịch chèn lên lịch ưu tiên khác đã tồn tại trên hệ thống.'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: false,
          horizontal: {
            label: 'col-sm-3',
            input: 'col-sm-9'
          }
        },
        data: {
          name: "priority",
          items:
            [
              { key: "0", value: "Không ưu tiên" },
              { key: "1", value: "Ưu tiên" },
            ],
          model: "0",
        },
      },
      modeSchedule: {
        options: {
          label: "Kiểu lịch " +
            "<span class='explain-modeSchedule' data-toggle='tooltip' data-html='true' title='<div class=\"text-left\"><b>-Theo ngày trong tuần:</b> Lịch đặt cho các thiết bị phát thanh với nguồn phát được" +
            " chọn trong khoảng ngày hiệu lực và chứa các ngày trong tuần (thứ 2, thứ 3..) " +
            "<i><br/>(Ví dụ: Ngày bắt đầu-Ngày kết thúc là 01/10/2022 - 30/10/2022 với ngày phát được thọn là thứ 2, thứ 3, thứ 4, thời gian phát là 05:00 và 17:00, các thiết bị sẽ phát thanh " +
            "vào 05:00 sáng và 17:00 chiều thứ 2, thứ 3, thứ 4 trong khoảng hiệu lực từ ngày 01 đến 30 tháng 10, các ngày thứ 5,6,7 và chủ nhật sẽ không phát thanh)</i>" +
            "<br/><b>-Theo ngày trong tháng:</b> Lịch đặt cho các thiết bị phát thanh với nguồn phát được chọn trong khoảng ngày hiệu lực và chứa các ngày chỉ định (ngày 10,11,12)" +
            "<br/><i>(Ví dụ: Ngày bắt đầu-Ngày kết thúc là 01/10/2022 - 30/10/2022 với ngày phát được chọn là ngày 14,17,18, thời gian phát là 05:00 và 17:00, các thiết bị sẽ phát thanh" +
            " vào 05:00 sáng và 17:00 chiều các ngày 14,17,18 trong khoảng hiệu lực từ ngày 01 đến 30 tháng 10, các ngày còn lại không được chọn sẽ không phát thanh)</i>'</div>" +
            "<i class='fa fa-question-circle-o' style='font-size: 18px; cursor: pointer'></i>" +
            "</span>",
          filter: false,
          horizontal:
          {
            label: 'col-sm-3',
            input: 'col-sm-9'
          }
        },
        data: {
          name: "modeSchedule",
          items:
            [
              { key: "0", value: "Theo ngày trong tuần" },
              { key: "1", value: "Theo ngày trong tháng" },
            ],
          model: "0",
        },
      },
      deviceInput: {
        data: {
          name: 'deviceIds',
          model: []
        },
        validator: {
          isValid: true,
          errorMessage: "",
          valid:
            function () {
              let value = that.deviceInput.data.model;
              if (value === "" || value.length == 0) {
                this.isValid = false;
                // that.showErrorMsg({message: 'Thiết bị phát không được để trống'})
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
        }
      },
      resetDevice: false,
      validDevice: false,
      selectedDateWeek:
      {
        options: {
          label: "Ngày phát",
        },
        data: {
          name: "selectedDateWeek",
          model: "",
          items:
            [
              { key: "2", value: "Thứ 2" },
              { key: "3", value: "Thứ 3" },
              { key: "4", value: "Thứ 4" },
              { key: "5", value: "Thứ 5" },
              { key: "6", value: "Thứ 6" },
              { key: "7", value: "Thứ 7" },
              { key: "1", value: "Chủ nhật" },
            ],
          validator:
          {
            isValid: true,
            errorMessage: "",
            valid:
              function () {
                let value = that.selectedDateWeek.data.model;
                if ((value === "" || value.length == 0) &&
                  that.modeSelect.data.model == 1 && that.modeSchedule.data.model == 0) {
                  this.isValid = false;
                  this.errorMessage = "Ngày phát không được để trống";
                  that.scrollToValidate(that.$refs.selectedDateWeek.scrollHeight)
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              },
          },
        },
      },
      validatorRangeTimes: {
        isValid: true,
        errorMessage: "",
        valid:
          function () {
            let value = that.timeRange;
            if ((value === "" || value.length == 0) && that.modeSelect.data.model != 2) {
              this.isValid = false;
              this.errorMessage = "Thời gian phát không được để trống";
              that.scrollToValidate(that.$refs.rangeTimes.scrollHeight)
            } else {
              var validRes = that.validateRangeTimeSorted();
              this.isValid = validRes.isValid;
              if (this.isValid) {
                this.errorMessage = "";
              } else {
                if (validRes.type == 0) {
                  this.errorMessage = "Thời gian bắt đầu phải lớn hơn hoặc bằng thời gian hiện tại";
                } else if (validRes.type == 1) {
                  this.errorMessage = "Thời gian bắt đầu phải nhỏ hơn thời gian kết thúc";
                } else {
                  this.errorMessage = "Khoảng thời gian phát bị trùng nhau";
                }
                that.scrollToValidate(that.$refs.rangeTimes.scrollHeight)
              }
            }
            return this.isValid;
          },
      },
      validatorDates: {
        isValid: true,
        errorMessage: "",
        valid:
          function () {
            let value = that.dates;
            if (
              (value === "" || value.length == 0) &&
              that.modeSelect.data.model == 1 &&
              that.modeSchedule.data.model == 1
            ) {
              this.isValid = false;
              this.errorMessage = "Ngày phát phát không được để trống";
              that.scrollToValidate(that.$refs.rangeDates.scrollHeight)
            } else {
              this.isValid = true;
            }
            return this.isValid;
          },
      },
      validatorEndTimeUrgency: {
        isValid: true,
        errorMessage: "",
        valid:
          function () {
            if(that.modeSelect.data.model == 2 && that.modeTimeSelect.data.model == 1) {
              let value = that.endTimeUrgency.getTime();
              if (value !== "") {
                if (value <= new Date()) {
                  this.isValid = false;
                  this.errorMessage = "Thời gian kết thúc phát phải lớn hơn thời gian hiện tại";
                  that.scrollToValidate(that.$refs.endTimeUrgency.$el.scrollHeight)
                } else {
                  this.isValid = true;
                }
              }
            }
            
            return this.isValid;
          },
      },
      chooseFileData: {
        isShowModal: false,
        fileTable:
        {
          options: {
            fields: [
              { key: "name", label: "Tên", _style: 'width: 40%;' },
              { key: "url", label: "File", _style: 'width: 30%;' },
              { key: "size", label: "Dung lượng (Mb)", _style: 'width: 10%;' },
              { key: "action", label: "Thao tác", _style: 'width: 10%;' }
            ],
            slots:
              ["index", "name", "size", "url", "action"],
          },
          data: {
            items: [
              { name: 123, label: 555 },
              { name: 1234, label: 4444 }
            ]
          }
        }
      },
    }
  },
  computed: {
    checkDisableAddDate() {
      let number = this.dateRange.end.getTime() - this.dateRange.start.getTime();
      const daysDiff = number / (1000 * 60 * 60 * 24);
      if (this.dates.length <= daysDiff) {
        return false;
      }
      return true;
    }
  },
  methods: {
    scrollToValidate(scrollHeight) {
      setTimeout(() => {
        window.scrollTo({ left: 100, top: scrollHeight, behavior: "smooth" });
      }, 100);
    },
    changeSelectedAllLocation(value) {
      if (value) {
        this.locationScheduleSelected.data.model = this.locationScheduleSelected.options;
      } else {
        this.locationScheduleSelected.data.model = '';
      }
    },
    changeSelectedDevice(value) {
      this.deviceInput.data.model = value;
    },
    unSelectedDevice(value) {
      this.actionData.model.deviceIgnoreIds = value;
    },
    dataSearch(value) {
      this.actionData.model.dataSearch = value;
    },
    clearSelectedAll() {
      this.resetDevice = false;
    },
    changeValidateDevice(value) {
      this.deviceInput.validator.isValid = !value;
    },
    chooseFile() {
      this.chooseFileData.isShowModal = true;
    },
    selectedAll(value) {
      this.actionData.model.selectedAll = value;
    },
    chooseFileSelected(value) {
      this.fileSelectedInput.data.model = value.id;
      this.fileSelectedInput.data.title = `${value.title} (${value.duration})`;
      this.duration = value.duration;
      this.chooseFileData.isShowModal = false;
    },
    closeModalChooseFile() {
      this.chooseFileData.isShowModal = false;
    },
    submitConfirm: function () {
      let that = this;
      that.isConfirm = false;
      that.exist.isShowModelExist = false;
      that.submitData();
    },
    loadDataLocationSchedule() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/common/findAllLocationByLevel",
        ignoreDefaultData: true,
        isJsonContentType: false,
        dataSubmit() {
          return {
            level: that.levelLocationSelect.data.model,
          }
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.locationScheduleSelected.options = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= that.titleInput.data.validator.valid();
      isValid &= that.validatorRangeTimes.valid();
      isValid &= that.selectedDateWeek.data.validator.valid();
      isValid &= that.validatorDates.valid();
      isValid &= that.channelDigitalSelect.data.validator.valid();
      isValid &= that.playListSelect.data.validator.valid();
      isValid &= that.fileSelectedInput.data.validator.valid();
      isValid &= that.validatorEndTimeUrgency.valid();
      if (that.scheduleBySelect.data.model == 1) {
        isValid &= that.deviceInput.validator.valid();
      } else {
        isValid &= that.locationScheduleSelected.data.validator.valid();
      }

      if (!isValid) {
        return;
      } else {
        let res = that.setupDataSubmit();
        that.$helper.loadDataSource({
          loading: that.loading,
          url: "/schedule/add",
          dataSubmit: function () {
            return res;
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              if (response.data.data.id) {
                that.exist.id = response.data.data.id;
                that.exist.msg = response.data.data.msg;
                that.exist.startTime = response.data.data.startTime;
                that.exist.endTime = response.data.data.endTime;
                that.exist.playDate = response.data.data.playDate;
                that.exist.devices = response.data.data.devices;
                that.exist.mode = response.data.data.modeSchedule;
                that.exist.locationName = response.data.data.locationName;
                that.exist.isShowModelExist = true;
              } else {
                that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
                that.$helper.setupErrorModel(response.data.data, that.$data);
              }
            } else {
              that.showSuccessMsg({ message: "Thêm mới lịch phát thành công" });
              that.$router.push("/radio-activities/managed-schedule.html");
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          },
        });
      }
    },
    setupDataSubmit() {
      let res = {};
      let dates = [];
      for (let i = 0; i < this.dates.length; i++) {
        dates.push(this.$helper.formatDateDDMMYYYY(this.dates[i].date.getTime()));
      }
      let startTimes = [];
      let endTimes = [];
      let times = [];
      let replays = [];
      for (let i = 0; i < this.timeRange.length; i++) {
        var startTime = this.$helper.formatHHMMSS(this.timeRange[i].start.getTime());
        var endTime = this.$helper.formatHHMMSS(this.timeRange[i].end.getTime());
        startTimes.push(startTime);
        endTimes.push(endTime);
        times.push(startTime + " - " + endTime);
        replays.push(this.timeRange[i].replay);
      }

      if (this.modeSelect.data.model == 2) {
        if(this.modeTimeSelect.data.model == 1) {
          endTimes.push(this.$helper.formatHHMMSS(this.endTimeUrgency.getTime()));
        } else {
          res.replayUrgency = this.replayUrgency;
        }
      }

      res.dates = dates;
      res.startTimes = startTimes;
      res.endTimes = endTimes;
      res.replays = replays;
      res.fromDate = this.$helper.formatDateDDMMYYYY(this.minDate.getTime());
      res.toDate = this.$helper.formatDateDDMMYYYY(this.maxDate.getTime());

      res.title = this.titleInput.data.model;
      res.typeSource = this.typeSourceSelect.data.model;
      res.mode = this.modeSelect.data.model;
      res.modeSchedule = this.modeSchedule.data.model;
      res.modeTime = this.modeTimeSelect.data.model;
      res.times = times;
      res.fileId = this.fileSelectedInput.data.model;
      res.duration = this.duration;
      res.channelDigitalId = this.channelDigitalSelect.data.model;
      res.playlistId = this.playListSelect.data.model;
      res.devices = this.deviceInput.data.model;
      res.scheduleBy = this.scheduleBySelect.data.model;
      if (this.selectedDateWeek.data.model.length > 0) {
        res.selectedDateWeek = [];
        for (let i = 0; i < this.selectedDateWeek.data.model.length; i++) {
          res.selectedDateWeek.push(this.selectedDateWeek.data.model[i].key);
        }
      }
      res.isConfirm = this.isConfirm;

      if(this.modeSelect.data.model == 2) {
        res.priority = false;
      } else {
        if(this.prioritySelect.data.model == 1) {
          res.priority = true;
        } else {
          res.priority = false;
        }
      }

      if (this.locationScheduleSelected.data.model.length > 0) {
        res.scheduleLocationCode = [];
        for (let i = 0; i < this.locationScheduleSelected.data.model.length; i++) {
          res.scheduleLocationCode.push(this.locationScheduleSelected.data.model[i].key);
        }
      }
      res.deviceIgnoreIds = this.actionData.model.deviceIgnoreIds;
      res.searchDeviceModel = this.actionData.model.dataSearch;
      res.selectedAll = this.actionData.model.selectedAll;
      return res;
    },

    addTimeRange() {
      if (this.timeRange.length == 0) {

        var startTime = this.$helper.plusDateTime(5, 'm').second(0).millisecond(0)._d;
        var endTime = this.$helper.plusDateTime(13, 'm').second(0).millisecond(0)._d;

        if(this.modeTimeSelect.data.model == 0) {
          var duration = this.duration;

          endTime = this.$helper.calculatorEndTime(startTime, duration, 1)._d; 
          
        }

        this.timeRange.push(
        {
          start: startTime,
          end: endTime,
          isValid: false,
          replay: 1
        })

        
      } else {
        var rangeTimeSorted = this.sortRangeTime();
        var timeEnd = rangeTimeSorted[rangeTimeSorted.length - 1].end;
        var endTime = moment(timeEnd).add(10, 'm').second(0).millisecond(0).toDate();

        if(this.modeTimeSelect.data.model == 0) {
          var duration = this.duration;

          endTime = this.$helper.calculatorEndTime(timeEnd, duration, 1)._d; 

        }

        this.timeRange.push({
          start: timeEnd,
          end: endTime,
          isValid: false,
          replay: 1
        })
      }

    },
    regexReplay(replay) {
      return /^[1-9][0-9]*$/.test(replay);
    },
    changeReplayUrgency(replay) {
      if (!this.regexReplay(replay)) {
        this.replayUrgency = 1;
      }
    },
    changeTimeRange(event, index, replay) {
      if(this.modeTimeSelect.data.model == 0) {

        if (!this.regexReplay(replay)) {
          replay = 1
        }

        var duration = this.duration;

        var endTime = this.$helper.calculatorEndTime(event, duration, replay)._d;

        this.timeRange.splice(index, 1,  {
            start: event,
            end: endTime,
            isValid: false,
            replay: replay
        });
      } else {
        this.timeRange.splice(index, 1, event);
      }
      
    },

    sortRangeTime(isClick) {
      var timeArr = this.timeRange;
      var sortedTime = [];
      var tempTimesArr = [];
      timeArr.forEach(function (each, index) {
        tempTimesArr.push({ time: moment(each.start, "hh:mm:ss").unix(), index: index });
      });
      tempTimesArr.sort(function (a, b) {
        return a.time - b.time;
      });

      tempTimesArr.forEach(function (t) {
        sortedTime.push(timeArr[t.index])
      });
      if (isClick) {
        this.timeRange = sortedTime;
      } else {
        return sortedTime;
      }
    },

    validateRangeTimeSorted() {
      
      var rangeTimeSorted = this.sortRangeTime();
      var response = {
        isValid: true,
      }
      var now = moment().second(0).millisecond(0)._d.getTime();
      var mode = this.modeSelect.data.model;
      var modeSchedule = this.modeSchedule.data.model;
      var minDate = new Date();

      if (mode != 2 && modeSchedule == 1) {
        minDate = this.getMinDate(this.dates);
      }
      var fromDate = new Date(this.minDate.getTime());
      var toDate = new Date(this.maxDate.getTime());
      fromDate.setHours(0, 0, 0);
      toDate.setHours(0, 0, 0);

      var selectedDateWeek = [];

      if (this.selectedDateWeek.data.model.length > 0) {
        selectedDateWeek = [];
        for (let i = 0; i < this.selectedDateWeek.data.model.length; i++) {
          selectedDateWeek.push(this.selectedDateWeek.data.model[i].key);
        }
      }

      for (let i = 0; i < rangeTimeSorted.length; i++) {

        if (mode == 0) {
          var _from = new Date(this.dateRange.start.setHours(rangeTimeSorted[i].start.getHours(), rangeTimeSorted[i].start.getMinutes(), 0));
          if (_from < now) {
            response.isValid = false;
            response.type = 0;
            break;
          }
        } else if (mode == 1) {
          if (modeSchedule == 1) {
            var _from = new Date(minDate.setHours(rangeTimeSorted[i].start.getHours(), rangeTimeSorted[i].start.getMinutes(), 0));
            if (_from < now) {
              response.isValid = false;
              response.type = 0;
              break;
            }
          } else {
            while (fromDate <= toDate) {
              if (selectedDateWeek.includes(fromDate.getDay() + 1 + "")) {
                var _from = new Date(fromDate.setHours(rangeTimeSorted[i].start.getHours(), rangeTimeSorted[i].start.getMinutes(), 0));
                if (_from < now) {
                  response.isValid = false;
                  response.type = 0;
                  break;
                }
              }
              fromDate.setDate(fromDate.getDate + 1);
            }
          }
        }

        if (rangeTimeSorted[i].start.getTime() >= rangeTimeSorted[i].end.getTime()) {
          response.isValid = false;
          response.type = 1;
          break;
        }

        if (i > 0) {
          if (rangeTimeSorted[i].start.getTime() < rangeTimeSorted[i - 1].end.getTime()) {
            response.isValid = false;
            response.type = 2;
            break;
          }
        }
      }
      return response;
    },

    getMinDate(dates) {
      let minDate = dates[0];

      for (let i = 1; i < dates.length; i++) {
        if (dates[i] < minDate) {
          minDate = dates[i];
        }
      }

      return minDate.date;
    },

    removeTimeRange(index) {
      this.timeRange.splice(index, 1);
    },
    addDate() {
      let that = this;

      let number = this.dateRange.end.getTime() - this.dateRange.start.getTime();
      const daysDiff = number / (1000 * 60 * 60 * 24);
      if (daysDiff < this.dates.length) {
        return;
      }

      var date = new Date();
      date.setDate(this.dateRange.start.getDate());
      this.dates.push({ date: date });
      this.$nextTick(() => {
        setTimeout(() => {
          const btn = that.$refs.btnDate[that.$refs.btnDate.length - 1];
          btn.click();
        }, 50);
      });
    },
    removeDate(date, hide) {
      this.dates = this.dates.filter((d) => d !== date);
      hide();
    },
    dateSelected(e, date, toggle) {
      this.selectedDate = date;
      toggle({ ref: e.target });
    },
    resetData() {
      const today = new Date();
      // Core text / selects (back to initial defaults)
      this.titleInput.data.model = "";
      this.typeSourceSelect.data.model = "0";
      this.playListSelect.data.model = "";
      this.channelDigitalSelect.data.model = "";
      this.scheduleBySelect.data.model = this.$hasAuthor("ROLE_VILLAGE") ? "1" : "0";
      this.prioritySelect.data.model = "0";
      this.modeSelect.data.model = "0";
      this.modeSchedule.data.model = "0";
      this.levelLocationSelect.data.model =
        this.$hasAuthor("ROLE_PROVINCE") ||
        this.$hasAuthor("ROLE_ADMIN") ||
        this.$hasAuthor("ROLE_MANAGEMENT")
          ? "1"
          : "2";

      // Dates / times
      this.minDate = today;
      this.maxDate = today;
      this.endTimeUrgency = this.$helper.plusDateTime(10, "m")._d;
      this.replayUrgency = 1;
      this.duration = "00:00:00";
      this.timeRange = [];
      this.dateRange = {
        start: this.minDate,
        end: this.maxDate,
      };
      this.selectedDate = {};

      // Devices / locations / misc
      this.isSelectedAllLocation = false;
      this.locationScheduleSelected.data.model = [];
      this.locationScheduleSelected.options = [];
      this.deviceInput.data.model = [];
      this.actionData.model = {
        listFileSelectedId: [],
        deviceIgnoreIds: [],
        dataSearch: {},
        selectedAll: false,
      };
      this.isConfirm = true;
      this.exist = {
        id: "",
        msg: "",
        playDate: "",
        startTime: "",
        endTime: "",
        devices: [],
        isShowModelExist: false,
        mode: "",
        locationName: "",
      };
      this.chooseFileData.isShowModal = false;

      // Reset validators UI state
      this.titleInput.data.validator.isValid = true;
      this.titleInput.data.validator.errorMessage = "";
      this.fileSelectedInput.data.validator.isValid = true;
      this.fileSelectedInput.data.validator.errorMessage = "";
      this.channelDigitalSelect.data.validator.isValid = true;
      this.channelDigitalSelect.data.validator.errorMessage = "";
      this.playListSelect.data.validator.isValid = true;
      this.playListSelect.data.validator.errorMessage = "";
      this.locationScheduleSelected.data.validator.isValid = true;
      this.locationScheduleSelected.data.validator.errorMessage = "";
      this.selectedDateWeek.data.validator.isValid = true;
      this.selectedDateWeek.data.validator.errorMessage = "";
      this.deviceInput.validator.isValid = true;
      this.deviceInput.validator.errorMessage = "";
      this.validatorRangeTimes.isValid = true;
      this.validatorRangeTimes.errorMessage = "";
      this.validatorDates.isValid = true;
      this.validatorDates.errorMessage = "";
      this.validatorEndTimeUrgency.isValid = true;
      this.validatorEndTimeUrgency.errorMessage = "";

      // modeTimeSelect follows typeSource (same logic as watcher on typeSourceSelect)
      if (this.typeSourceSelect.data.model == "0" || this.typeSourceSelect.data.model == "3") {
        this.modeTimeSelect.data.model = "0";
      } else {
        this.modeTimeSelect.data.model = "1";
      }

      this.resetTime();
      this.resetDevice = true;

      this.fileSelectedInput.data.model = "";
      this.fileSelectedInput.data.title = "";

      // Reload dependent lists
      this.$nextTick(() => {
        this.loadDataLocationSchedule();
        if (this.$refs.channelDigitalSelect) {
          setTimeout(() => this.$refs.channelDigitalSelect.loadData(), 50);
        }
        if (this.$refs.playListSelect) {
          setTimeout(() => this.$refs.playListSelect.loadData(), 50);
        }
      });
    },
    resetTime() {
      this.startTimes = [];
      this.endTimes = [];
      this.selectedDateWeek.data.model = [];
      this.dates = [];
    },
    reloadTooltipExplain() {
      setTimeout(() => {
        const options = {
          // placement: 'right',
          boundary: 'window',
        }
        var elm = document.getElementsByClassName("explain");
        for (var each of elm) {
          new coreui.Tooltip(each, options);
        }
        var elmModeSchedule = document.getElementsByClassName("explain-modeSchedule");
        for (var each of elmModeSchedule) {
          new coreui.Tooltip(each, {
            placement: 'right',
          });
        }
        // $('[data-toggle="tooltip"]').tooltip(options);
      }, 100);
    }
  },
  created: function () {

  },
  mounted() {
    const options = {
      placement: 'bottom'
    }
    $('[data-toggle="tooltip"]').tooltip(options);
    this.loadDataLocationSchedule();
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.minDate = newValue.start;
        this.maxDate = newValue.end;
      }
      this.dates = [];
    },
    "modeSelect.data.model": function (newValue) {
      if (newValue) {
        if (newValue == 2) {
          this.minDate = new Date();
          this.maxDate = new Date();
        }
        this.resetTime();
      }
      this.reloadTooltipExplain();
    },
    "modeSchedule.data.model": function (newValue) {
      if (newValue) {
        this.resetTime();
      }
      this.reloadTooltipExplain();
    },
    'typeSourceSelect.data.model': function (value) {
      this.reloadTooltipExplain();
      if (value == 2) { /* Kênh Số Hóa */
        let that = this;
        setTimeout(() => {
          that.$refs.channelDigitalSelect.loadData();
        }, 50)
      } else if (value == 3) { /* Danh sách phát */
        let that = this;
        setTimeout(() => {
          that.$refs.playListSelect.loadData();
        }, 50)
      } else {
        this.playListSelect.data.items = [];
      }
      this.fileSelectedInput.data.model = '';
      this.fileSelectedInput.data.title = '';
      if(value == 0 || value == 3) {
        this.modeTimeSelect.data.model = 0;
      } else {
        this.modeTimeSelect.data.model = 1;
      }
    },
    "levelLocationSelect.data.model": function (newValue) {
      if (newValue) {
        // Reset selected locations when changing location level.
        // Otherwise vue-multiselect keeps the old selected values.
        this.isSelectedAllLocation = false;
        this.locationScheduleSelected.data.model = [];
        this.locationScheduleSelected.options = [];
        this.loadDataLocationSchedule();
      }
    },
    "duration": function(newValue) {
      if(newValue) {
        // console.log(this.timeRange);
        let that = this;
        if(that.timeRange) {
          for (let i = 0; i < that.timeRange.length; i++) {
            that.timeRange[i].end = that.$helper.calculatorEndTime(that.timeRange[i].start, newValue, that.timeRange[i].replay)._d;
          }
        }
      }
    },
    "modeTimeSelect.data.model": function (newValue) {
      if (newValue) {
        this.timeRange = [];
      }
    },
    "playListSelect.data.model": function (newValue) {
      if(newValue) {
        let that = this;
        that.loading.value = true;
        that.$helper.loadDataSource({
          url: "/play-list/find-by-id",
          dataSubmit: function () {
            return {id: newValue}
          },
          isJsonContentType: false,
          successCallback: function (response) {
            if (that.$helper.validResponse(that.$router, response.data)) {
              let data = response.data.data;
              that.duration = data.duration;
              that.loading.value = false;
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
            that.loading.value = false;
          },
        });
        
      }
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.btn-date:hover .btn-remove {
  display: inline-flex !important;
}

.btn-remove {
  display: none !important;
  position: absolute;
  width: 15px;
  height: 15px;
  background: red;
  color: white;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  top: -5px;
  right: -5px;
}

.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before {
  border-color: unset;
  background-color: unset;
}

.form-group.input-error .card {
  border-color: #ff7070 !important;
}

.btn-time-ranger:hover~.btn-remove-time {
  display: inline-block !important;
}

.btn-remove-time {
  width: 18px;
  cursor: pointer;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 0;
  padding: 2px;
  border-radius: 50%;
  background: red;
  color: white;
}
</style>
<style lang="scss">
#addSchedule {

  .modal-chooseFile {

    .modal-dialog {
      height: 90vh;

      .modal-content {
        height: 100%;

        .modal-body {
          height: 100%;
          overflow: auto;

          &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
            background-color: rgba(127, 127, 127, .2) !important;
          }

          &::-webkit-scrollbar-thumb {
            background-color: #39a2ff !important;
          }

          &::-webkit-scrollbar-track {
            --webkit-box-shadow: inset 0 0 6px rgba(127, 127, 127, .2);
            background-color: white !important
          }
        }
      }
    }
  }

  .input-error {
    #endTimeUrgencyPicker {
      border-color: #ff7070;
    }
  }

  .override-custom {
    opacity: 0 !important;
  }

}
</style>
<style>
/*.tooltip {*/
/*  max-width: unset !important;*/
/*  width: 500px !important;*/
/*}*/

/*.tooltip-arrow {*/
/*  max-width: unset !important;*/
/*  width: 500px !important;*/
/*}*/

.tooltip-inner {
  max-width: unset !important;
  width: 250px !important;
}
</style>
